import { apiStatus } from '@va/constants';
import { getApiRequest, getApiRequestStatus } from '@va/standalone/shared/selectors';
import { AgencyUI } from '@va/types/agency-ui';
import { useSelector } from 'react-redux';

const useAgencyUi = () => {
  const data: AgencyUI | null = useSelector((state) => getApiRequest(state, 'getAgencyUi'))
    ?.get('data')
    ?.toJS();
  const status: apiStatus = useSelector((state) => getApiRequestStatus(state, 'getAgencyUi'));

  return { data, status };
};

export default useAgencyUi;
